import { useEffect, useState } from 'react';

import { useAppSelector } from '../../../hooks';
import { getUser } from '../../../store/selectors/user.selector';

export const useOnboarding = () => {
  const [showOnboarding, setShowOnboarding] = useState(false);
  const user = useAppSelector(getUser);

  useEffect(() => {
    const dismissed = !user || user.settings?.hideOnboardingPopup;
    if (!dismissed) {
      const timer = setTimeout(() => {
        setShowOnboarding(true);
      }, 500);
      return () => clearTimeout(timer);
    }

    setShowOnboarding(false);
  }, [user]);

  const closeOnboarding = () => {
    setShowOnboarding(false);
  };

  return {
    showOnboarding,
    closeOnboarding,
  };
};
